<h2 [translate]="'widgets.teamMood.editQuestionnaires'">Edit mode</h2>
<div>
  <div class="content">
    <ul class="list-question">
      <li *ngFor="let option of allQuestions">
        <table class="table-question">
          <tr>
            <th>
              <mat-slide-toggle [checked]="option.active" (change)="changeActive(option.id)"></mat-slide-toggle>
            </th>
            <th>
              <input placeholder="Question" class="textarea-question" id="question-id-{{option.id}}"
                          (change)="changeName(option.id, option.name)" [(ngModel)]="option.name"/>
            </th>
            <th>
              <button [style.background]="option.color"
                [cpOutputFormat]="'rgba'"
                [(colorPicker)]="option.color"
                [cpCancelButton]="true"
                (colorPickerChange)="changeColor(option.id, $event)"
                class="colorPickerButton">
                <mat-icon>brush</mat-icon></button>
            </th>
          </tr>
          <tr>
            <th>
              <button mat-raised-button id="button-del-question-{{option.id}}" (click)="deleteQuestion(option.id)">
                <mat-icon>delete</mat-icon>
              </button>
            </th>
            <hr class="hr-question">
          </tr>
        </table>
      </li>
      <li>
        <table>
          <th>
            <textarea class="textarea-question-add-new" id="newQuestion" placeholder="{{placeholderNewVote}}"
                      [(ngModel)]="newQuestionValue"></textarea>
          </th>
          <th>
            <button [style.background]="newQuestionColor"
              [cpOutputFormat]="'rgba'"
              [(colorPicker)]="newQuestionColor"
              class="colorPickerButton">
              <mat-icon>brush</mat-icon></button>
          </th>
          <th>
            <button mat-raised-button id="button-question-add" (click)="addNewQuestion()"
                    *ngIf="newQuestionValue && newQuestionValue !== ''">
              <mat-icon>save</mat-icon>
            </button>
          </th>
        </table>
      </li>
    </ul>
  </div>

  <div class="editQuestionfooter">
    <p>
      <button mat-raised-button *ngIf="!initialized" (click)="initQuestions()">
        <mat-icon aria-hidden="false" >autorenew</mat-icon>
      </button>
      <button mat-mini-fab color="accent" type="button" class="btn btn-success" (click)="confirm()" [translate]="'widgets.teamMood.vote'">
        <mat-icon aria-hidden="false" >done</mat-icon>
      </button>
      <button mat-mini-fab color="clear"  type="button" (click)="cancel()" [translate]="'widgets.teamMood.cancelVote'">
        <mat-icon aria-hidden="false" >clear</mat-icon>
      </button>
    </p>
  </div>
</div>
